import { SCREEN_RESIZE } from "constants/actionTypes";

export function screenResize(width) {
  return {
    type: SCREEN_RESIZE,
    width,
  };
}
